































import { Vue, Component, Watch, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import userStore from '@/modules/auth/auth.store'
import tournamentStore from '@/modules/tournament/tournament.store'
import ServerError from '@/utils/server_error'
import TournamentCard from '@/modules/tournament/components/TournamentCard'
import TournamentDetailsHeader from '@/modules/tournament/components/TournamentDetailsHeader'
import { TournamentAction } from '@/modules/tournament/components/TournamentBasicInformation/TournamentBasicInformation.vue'
import Swiper from 'swiper'
import { MemberJoinedTournamentsEntity } from '@/api/tournament'

const slidesPerView = 4

@Component({
  components: {
    TournamentCard,
    TournamentDetailsHeader
  }
})
export default class AppSwiper extends Vue {
  userModule = getModule(userStore, this.$store)
  tournamentModule = getModule(tournamentStore, this.$store)

  @Prop({ default: '' }) readonly header!: string
  @Prop({ default: true }) readonly isVisible!: boolean

  // swiper
  appSwiper: Swiper | null = null

  /* Hooks */
  async mounted() {
    await this.fetchTournamentCatalog()
    this.appSwiper = new Swiper(`#${this.elementHeader}-swiper-container`, {
      ...this.options,
      on: {
        slideChange: this.onSlideChanged
      }
    })
  }

  /* Computed Properties */
  get options() {
    return {
      slidesPerView,
      spaceBetween: 30,
      navigation: {
        nextEl: `#${this.elementHeader}-swiper-button-next`,
        prevEl: `#${this.elementHeader}-swiper-button-prev`
      },
      keyboard: {
        enabled: true,
        onlyInViewport: false
      },
      mousewheel: {
        invert: true
      }
    }
  }

  get elementHeader() {
    return this.header.toLowerCase().replace(' ', '-')
  }

  get swiperName() {
    return `${this.elementHeader}-swiper`
  }

  /* Watchers */
  @Watch('isVisible')
  onVisibleChanged(isVisible: boolean) {
    // use $nextTick fails to trigger swiper update
    setTimeout(() => {
      this.appSwiper!.update()
    }, 0)
  }

  /* Vuex State */
  async fetchTournamentCatalog() {
    try {
      await this.tournamentModule.fetchTournamentCatalog()
    } catch (err) {
      if (err instanceof ServerError) {
        this.$toast.error(err.getMessage())
      } else {
        this.$toast.error(this.$t('AppSwiper.SystemErrorMessage'))
        console.error(err)
      }
    }
  }

  get joinedTournaments(): MemberJoinedTournamentsEntity[] {
    return this.tournamentModule.joinedTournaments
  }

  /* Vuex State */
  get tournamentCatalog() {
    return this.tournamentModule.tournamentCatalog
  }

  get hasLoggedIn() {
    return this.userModule.hasLoggedIn
  }

  /* Vuex Actions */
  async fetchMoreTournamentCatalog() {
    try {
      await this.tournamentModule.fetchTournamentCatalog(
        this.tournamentModule.currentPage + 1
      )
    } catch (err) {
      if (err instanceof ServerError) {
        this.$toast.error(err.getMessage())
      } else {
        this.$toast.error(this.$t('AppSwiper.SystemErrorMessage'))
        console.error(err)
      }
    }
  }

  /* Methods */
  async onSlideChanged() {
    if (
      this.appSwiper!.activeIndex /
        (this.tournamentCatalog.length - slidesPerView) >
      0.7
    ) {
      await this.fetchMoreTournamentCatalog()
      this.appSwiper!.update()
    }
  }

  getTournamentAction(tournamentId: string): TournamentAction {
    if (
      this.joinedTournaments
        .map(tournament => tournament.tournamentId)
        .includes(tournamentId)
    ) {
      return TournamentAction.ViewTournament
    }
    return TournamentAction.JoinTournament
  }
}
